export default __webpack_public_path__ + "static/media/rotate-left.146e9373.svg";